import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { styled, Container as Container$1 } from '@mui/material';
import { spacing } from '@mui/system';
import { shouldNotForwardProps, spacing as spacing$1 } from '../../foundation/utils.js';

let _ = t => t,
  _t;
const ContainerStyled = styled(Container$1, {
  shouldForwardProp: shouldNotForwardProps
})(_t || (_t = _`
  ${0};

  padding-left: ${0};
  padding-right: ${0};
  ${0} {
    padding-left: ${0};
    padding-right: ${0};
  }
`), spacing, spacing$1(6), spacing$1(6), ({
  theme
}) => theme.breakpoints.up('sm'), spacing$1(10), spacing$1(10));
const Container = props => {
  return jsx(ContainerStyled, Object.assign({
    disableGutters: true
  }, props, {
    children: props.children
  }));
};

export { Container };
